import { render, staticRenderFns } from "./iconFrom.vue?vue&type=template&id=6a2994e1&scoped=true"
import script from "./iconFrom.vue?vue&type=script&lang=js"
export * from "./iconFrom.vue?vue&type=script&lang=js"
import style0 from "./iconFrom.vue?vue&type=style&index=0&id=6a2994e1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2994e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mer_supplier_admin_pSW1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2994e1')) {
      api.createRecord('6a2994e1', component.options)
    } else {
      api.reload('6a2994e1', component.options)
    }
    module.hot.accept("./iconFrom.vue?vue&type=template&id=6a2994e1&scoped=true", function () {
      api.rerender('6a2994e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/iconFrom.vue"
export default component.exports